import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import ExternalAppIframe from './RescueNetLive';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

export default (element, store) => {
  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ExternalAppIframe />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );
};
